<div class="modal-container">
    <div class="modal-header">
        <h2 mat-dialog-title>
            <mat-icon>print</mat-icon>
            <span>Pré-visualização de Impressão</span>
        </h2>
        <button mat-icon-button (click)="fechar()">
            <mat-icon>close</mat-icon>
        </button>
    </div>

    <div class="content-body" #contentBody>
        <iframe
            #previewFrame
            class="preview-iframe"
            scrolling="no"
            [srcdoc]="safeHtml"
            (load)="onIframeLoad()"></iframe>
    </div>

    <div class="modal-footer">
        <div class="page-indicator" aria-label="Navegação de páginas">
            <span class="page-label">Página</span>
            <input
                class="page-input"
                type="text"
                inputmode="numeric"
                [value]="paginaInformada"
                (input)="paginaInformada = $any($event.target).value"
                (keydown)="onPaginaInputKeydown($event)"
                (blur)="onPaginaInputBlur()"
                (focus)="onPaginaInputFocus($event)"
                aria-label="Página atual" />
            <span class="page-total">/ {{ totalPaginas }}</span>
        </div>

        <div class="footer-actions">
            <button mat-stroked-button class="btn-secondary" (click)="fechar()">Cancelar</button>
            <button mat-flat-button class="btn-primary" (click)="imprimir()" [disabled]="isPrinting">
                @if (isPrinting) {
                <mat-spinner diameter="20"></mat-spinner>
                } @else {
                <span>Imprimir etiquetas</span>
                }
            </button>
        </div>
    </div>
</div>
